interface StreamingRowBehaviorOptions {
  isStreaming: boolean;
  isDbAiFirstCreationEnabled: boolean;
  isAiFieldStreaming: boolean;
  entryId: string;
  entryIdSelectedForProcessing: string | undefined;
}

export const getStreamingRowBehavior = ({
  isStreaming,
  isDbAiFirstCreationEnabled,
  isAiFieldStreaming,
  entryId,
  entryIdSelectedForProcessing
}: StreamingRowBehaviorOptions) => {
  const isTargetStreamingRow = isStreaming && entryId === entryIdSelectedForProcessing;

  return {
    shouldShowAifcStreamingVisuals:
      isTargetStreamingRow && isDbAiFirstCreationEnabled && !isAiFieldStreaming,
    shouldAutoScrollToStreamingRow:
      isTargetStreamingRow && (isDbAiFirstCreationEnabled || isAiFieldStreaming)
  };
};
